import React from 'react';
import { lazyRoute } from '@/services/router/prefetch';

export const AssetLibrary = React.lazy(() =>
  import('@/features/asset-library').then((m) => ({ default: m.AssetLibrary })),
);

export const OAuth2 = lazyRoute('/oauth2/*', () => import('@/pages/oauth2.page'));
export const AIBusinessProfile = lazyRoute(
  '/workspaces/:workspaceId/settings/ai-business-profile',
  () => import('@/pages/workspaces/settings/ai-business-profile/index.page'),
);
export const WorkspaceAuditLogsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/audit-logs',
  () => import('@/pages/workspaces/settings/audit-logs.page'),
);
export const WebhookConfigurationPage = lazyRoute(
  '/workspaces/:workspaceId/settings/webhook_configuration',
  () => import('@/pages/workspaces/settings/webhook-configuration/index.page'),
);
export const WebhookConfigurationNewPage = lazyRoute(
  '/workspaces/:workspaceId/settings/webhook_configuration/new',
  () => import('@/pages/workspaces/settings/webhook-configuration/new.page'),
);
export const WebhookConfigurationEditPage = lazyRoute(
  '/workspaces/:workspaceId/settings/webhook_configuration/:webhookId/edit',
  () => import('@/pages/workspaces/settings/webhook-configuration/edit.page'),
);
export const WorkspaceBoardsPage = lazyRoute(
  '/workspaces/:workspaceId/boards',
  () => import('@/pages/workspaces/boards/index.page'),
);
export const WorkspaceBoardPage = lazyRoute(
  '/workspaces/:workspaceId/boards/:boardId',
  () => import('@/pages/workspaces/boards/[board-id]/index.page'),
);
export const WorkspaceAutoArchivePage = lazyRoute(
  '/workspaces/:workspaceId/settings/auto_archive',
  () => import('@/pages/workspaces/settings/auto-archive/index.page'),
);
export const WorkspaceEditPage = lazyRoute(
  '/workspaces/:workspaceId/settings/edit',
  () => import('@/pages/workspaces/settings/edit/index.page'),
);
export const WorkspaceConfirmDeletePage = lazyRoute(
  '/workspaces/:workspaceId/settings/confirm_delete',
  () => import('@/pages/workspaces/settings/confirm-delete/index.page'),
);
export const WorkspaceMergeOptionsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/merge_options',
  () => import('@/pages/workspaces/settings/merge-options/index.page'),
);
export const WorkspaceLlmConfigurationIndexPage = lazyRoute(
  '/workspaces/:workspaceId/settings/llm_configuration',
  () => import('@/pages/workspaces/settings/llm-configuration/index.page'),
);
export const WorkspaceLlmConfigurationNewPage = lazyRoute(
  '/workspaces/:workspaceId/settings/llm_configuration/new',
  () => import('@/pages/workspaces/settings/llm-configuration/new/index.page'),
);
export const WorkspaceLlmConfigurationEditPage = lazyRoute(
  '/workspaces/:workspaceId/settings/llm_configuration/:configurationId/edit',
  () => import('@/pages/workspaces/settings/llm-configuration/edit/index.page'),
);
export const WorkspaceLanguageSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/language',
  () => import('@/pages/workspaces/settings/language/index.page'),
);
export const WorkspaceObjectsSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/objects',
  () => import('@/pages/workspaces/settings/objects/index.page'),
);
export const WorkspaceObjectsSettingsEditPage = lazyRoute(
  '/workspaces/:workspaceId/settings/objects/edit/:objectType',
  () => import('@/pages/workspaces/settings/objects/edit/index.page'),
);
export const WorkspaceObjectsSettingsNewPage = lazyRoute(
  '/workspaces/:workspaceId/settings/objects/new',
  () => import('@/pages/workspaces/settings/objects/new/index.page'),
);
export const WorkspaceGeofencesSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/geofences',
  () => import('@/pages/workspaces/settings/geofences/index.page'),
);
export const WorkspaceSuppressionsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/suppressions',
  () => import('@/pages/workspaces/settings/suppressions/index.page'),
);
export const WorkspaceEmailSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email',
  () => import('@/pages/workspaces/settings/actions/email/index.page'),
);
export const WorkspaceEmailSendingDomainsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/sending_domains',
  () => import('@/pages/workspaces/settings/actions/email/sending-domains/index.page'),
);
export const WorkspaceEmailSendingDomainDetailPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/sending_domains/:domainId',
  () => import('@/pages/workspaces/settings/actions/email/sending-domains/[domain-id].page'),
);
export const WorkspaceEmailDynamicAddressesPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/dynamic_addresses',
  () => import('@/pages/workspaces/settings/actions/email/dynamic-addresses/index.page'),
);
export const WorkspaceEmailSmtpPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/smtp',
  () => import('@/pages/workspaces/settings/actions/email/smtp/index.page'),
);
export const WorkspaceEmailDefaultsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/defaults',
  () => import('@/pages/workspaces/settings/actions/email/defaults/index.page'),
);
export const WorkspaceEmailSuppressionListPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/email/suppression_list',
  () => import('@/pages/workspaces/settings/actions/email/suppression-list/index.page'),
);
export const WorkspaceUrlParamsSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/url_params',
  () => import('@/pages/workspaces/settings/actions/url_params/index.page'),
);
export const WorkspaceUrlParamsEditPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/url_params/edit',
  () => import('@/pages/workspaces/settings/actions/url_params/edit/index.page'),
);
export const WorkspaceCustomSmsSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/sms-providers',
  () => import('@/pages/workspaces/settings/actions/custom-sms/index.page'),
);
export const WorkspaceCustomSmsCredentialDetailPage = lazyRoute(
  '/workspaces/:workspaceId/settings/actions/sms-providers/credentials/:credentialId',
  () => import('@/pages/workspaces/settings/actions/custom-sms/credentials/[credential-id].page'),
);
export const AuditLogsPage = lazyRoute('/settings/audit-logs', () => import('@/pages/settings/audit-logs.page'));
export const PlansAndBillingPage = lazyRoute('/settings/billing', () => import('@/pages/settings/billing/index.page'));
export const YourPlanPage = lazyRoute(
  '/settings/billing/your-plan',
  () => import('@/pages/settings/billing/your-plan/index.page'),
);
export const BillingUsagePage = lazyRoute(
  '/settings/billing/usage',
  () => import('@/pages/settings/billing/usage/index.page'),
);
export const LlmUsagePage = lazyRoute(
  '/settings/billing/llm-usage',
  () => import('@/pages/settings/billing/llm-usage/index.page'),
);
export const InboxPreviewUsagePage = lazyRoute(
  '/settings/billing/inbox-preview-usage',
  () => import('@/pages/settings/billing/inbox-preview-usage/index.page'),
);
export const ProfileGrowthPage = lazyRoute(
  '/settings/billing/profile-growth',
  () => import('@/pages/settings/billing/profile-growth/index.page'),
);
export const BillingHistoryPage = lazyRoute(
  '/settings/billing/billing-history',
  () => import('@/pages/settings/billing/billing-history/index.page'),
);
export const AvailablePlansPage = lazyRoute(
  '/settings/billing/available-plans/journeys',
  () => import('@/pages/settings/billing/available-plans/index.page'),
);
export const PaymentMethodsPage = lazyRoute(
  '/settings/billing/payment-methods',
  () => import('@/pages/settings/billing/payment-methods/index.page'),
);
export const TrialExpiredPage = lazyRoute('/trial-expired/journeys', () => import('@/pages/trial-expired/index.page'));
export const CheckoutPage = lazyRoute(
  '/settings/billing/checkout',
  () => import('@/pages/settings/billing/checkout/index.page'),
);
// The top-level, chrome-less promo checkout page (`/checkout`), distinct from the in-app billing
// checkout tab above.
export const PromoCheckoutPage = lazyRoute('/checkout', () => import('@/pages/checkout/index.page'));
export const AiSettingsPage = lazyRoute('/settings/ai', () => import('@/pages/settings/ai/index.page'));
export const SettingsHomePage = lazyRoute('/settings', () => import('@/pages/settings/home/index.page'));
export const SlackSettingsPage = lazyRoute(
  '/settings/slack-agent',
  () => import('@/pages/settings/slack-agent/index.page'),
);
export const SlackLinkPage = lazyRoute(
  '/settings/slack-agent/link',
  () => import('@/pages/settings/slack-agent/link.page'),
);
export const PrivacySettingsPage = lazyRoute('/settings/privacy', () => import('@/pages/settings/privacy/index.page'));
export const SecuritySettingsPage = lazyRoute(
  '/settings/security',
  () => import('@/pages/settings/security/index.page'),
);
export const SsoSettingsPage = lazyRoute(
  '/settings/security/sso',
  () => import('@/pages/settings/security/sso/index.page'),
);
export const AccountSettingsPage = lazyRoute('/settings/account', () => import('@/pages/settings/account/index.page'));
export const AccountSettingsEditPage = lazyRoute(
  '/settings/account/edit',
  () => import('@/pages/settings/account/edit/index.page'),
);
export const AccountPartnerPage = lazyRoute(
  '/settings/partner',
  () => import('@/pages/settings/account/partner/index.page'),
);
export const AccountPartnerCreatePage = lazyRoute(
  '/settings/partner/create',
  () => import('@/pages/settings/account/partner/create.page'),
);
export const ExperimentalFeaturesPage = lazyRoute(
  '/settings/experimental-features',
  () => import('@/pages/settings/experimental-features/index.page'),
);
export const GoogleIdentitiesPage = lazyRoute(
  '/settings/personal/google-identities',
  () => import('@/pages/settings/personal/google-identities/index.page'),
);
export const PersonalSettingsPage = lazyRoute(
  '/settings/personal',
  () => import('@/pages/settings/personal/index.page'),
);
export const RolesPage = lazyRoute('/settings/roles', () => import('@/pages/settings/roles/index.page'));
export const TeamMembersPage = lazyRoute('/settings/team', () => import('@/pages/settings/team/index.page'));
export const TeamMemberAddPage = lazyRoute('/settings/team/add', () => import('@/pages/settings/team/add/index.page'));
export const TeamMemberEditPage = lazyRoute(
  '/settings/team/members/:userId/edit',
  () => import('@/pages/settings/team/edit/index.page'),
);
export const ApproveJoinRequestPage = lazyRoute(
  '/settings/team/join-requests/:requestId',
  () => import('@/pages/settings/team/approve-join-request/index.page'),
);
export const TeamMemberInviteGuestPage = lazyRoute(
  '/settings/team/invite-guest',
  () => import('@/pages/settings/team/invite-guest/index.page'),
);
export const WorkspacesSettingsPage = lazyRoute(
  '/settings/workspaces',
  () => import('@/pages/settings/workspaces/index.page'),
);
export const WorkspaceNewPage = lazyRoute(
  '/settings/workspaces/new',
  () => import('@/pages/settings/workspaces/new/index.page'),
);
export const NewRolePage = lazyRoute('/settings/roles/new', () => import('@/pages/settings/roles/new/index.page'));
export const RolePage = lazyRoute(
  '/settings/roles/:roleId',
  () => import('@/pages/settings/roles/[role-id]/index.page'),
);
// A param segment so hover-prefetch matches both taxonomy URL shapes — `/analysis/...` and
// the renamed `/reports/...`. Prefetching is only a hint, so matching one segment too many
// costs nothing.
export const DeliverabilityPage = lazyRoute(
  '/workspaces/:workspaceId/:reportsSegment/deliverability',
  () => import('@/pages/workspaces/analysis/deliverability/index.page'),
);
export const EmailClientsPage = lazyRoute(
  '/workspaces/:workspaceId/:reportsSegment/email-clients',
  () => import('@/pages/workspaces/analysis/email-clients/index.page'),
);
export const Agent = lazyRoute('/workspaces/:workspaceId/agent', () => import('@/pages/workspaces/agent/index.page'));
export const OutcomeOptimizationPage = lazyRoute(
  '/workspaces/:workspaceId/outcome-optimization',
  () => import('@/pages/workspaces/outcome-optimization/index.page'),
);
export const RoutinesPage = lazyRoute(
  '/workspaces/:workspaceId/agent/routines',
  () => import('@/pages/workspaces/agent/routines/index.page'),
);
export const SkillsPage = lazyRoute(
  '/workspaces/:workspaceId/agent/skills',
  () => import('@/pages/workspaces/agent/skills/index.page'),
);
export const SkillDetailPage = lazyRoute(
  '/workspaces/:workspaceId/agent/skills/:skillPath',
  () => import('@/pages/workspaces/agent/skills/skill-detail.page'),
);
export const NewSkillPage = lazyRoute(
  '/workspaces/:workspaceId/agent/skills/new',
  () => import('@/pages/workspaces/agent/skills/new-skill.page'),
);
export const HealthPage = lazyRoute(
  '/workspaces/:workspaceId/health',
  () => import('@/pages/workspaces/health/index.page'),
);
export const HomePage = lazyRoute('/workspaces/:workspaceId/home', () => import('@/pages/workspaces/home/index.page'));
export const AddPeoplePage = lazyRoute(
  '/workspaces/:workspaceId/home/add-people',
  () => import('@/pages/workspaces/home/add-people/index.page'),
);
export const AssetsPage = lazyRoute(
  '/workspaces/:workspaceId/assets',
  () => import('@/pages/workspaces/assets/index.page'),
);
export const ExportsPage = lazyRoute(
  '/workspaces/:workspaceId/exports',
  () => import('@/pages/workspaces/exports/index.page'),
);
export const DesignStudioDashboardPage = lazyRoute(
  '/workspaces/:workspaceId/design-studio/dashboard',
  () => import('@/pages/workspaces/design-studio/dashboard/index.page'),
);
export const DesignStudioGlobalStylesPage = lazyRoute(
  '/workspaces/:workspaceId/design-studio/global-styles',
  () => import('@/pages/workspaces/design-studio/global-styles/index.page'),
);
export const MessageLibraryPage = lazyRoute(
  '/workspaces/:workspaceId/message-library',
  () => import('@/pages/workspaces/message-library/index.page'),
);
export const LayoutsPage = lazyRoute(
  '/workspaces/:workspaceId/journeys/layouts',
  () => import('@/pages/workspaces/journeys/layouts/index.page'),
);
export const LayoutStartersPage = lazyRoute(
  '/workspaces/:workspaceId/journeys/layouts/starters',
  () => import('@/pages/workspaces/journeys/layouts/starters/index.page'),
);
export const LayoutDetailPage = lazyRoute(
  '/workspaces/:workspaceId/journeys/layouts/:layoutId',
  () => import('@/pages/workspaces/journeys/layouts/[layout-id]/index.page'),
);
export const LayoutEditPage = lazyRoute(
  '/workspaces/:workspaceId/journeys/layouts/:layoutId/edit',
  () => import('@/pages/workspaces/journeys/layouts/[layout-id]/edit.page'),
);
export const NewLayoutPage = lazyRoute(
  '/workspaces/:workspaceId/journeys/layouts/new',
  () => import('@/pages/workspaces/journeys/layouts/new/index.page'),
);
export const SnippetsLayout = lazyRoute(
  '/workspaces/:workspaceId/snippets',
  () => import('@/pages/workspaces/snippets/layout.page'),
);
export const SnippetsPage = lazyRoute(
  '/workspaces/:workspaceId/snippets',
  () => import('@/pages/workspaces/snippets/index.page'),
);
export const NewSnippetPage = lazyRoute(
  '/workspaces/:workspaceId/snippets/new',
  () => import('@/pages/workspaces/snippets/new/index.page'),
);
export const SnippetDetailPage = lazyRoute(
  '/workspaces/:workspaceId/snippets/:snippetId',
  () => import('@/pages/workspaces/snippets/[snippet-id]/index.page'),
);
export const CliPage = lazyRoute('/cli', () => import('@/pages/cli/index.page'));
export const AccountApiKeysPage = lazyRoute('/settings/api-keys', () => import('@/pages/settings/api-keys/index.page'));
export const WorkspaceApiKeysPage = lazyRoute(
  '/workspaces/:workspaceId/settings/api-keys',
  () => import('@/pages/settings/api-keys/workspace-page'),
);
export const AccountApiCredentialsPage = lazyRoute(
  '/settings/api_credentials',
  () => import('@/pages/settings/api-credentials/index.page'),
);
export const WorkspaceApiCredentialsPage = lazyRoute(
  '/workspaces/:workspaceId/settings/api_credentials',
  () => import('@/pages/settings/api-credentials/workspace-api-credentials.page'),
);
export const ServiceAccountDetailPage = lazyRoute(
  '/settings/api_credentials/service_accounts/:serviceAccountId',
  () => import('@/pages/settings/api-credentials/service-account-detail.page'),
);
export const DnsSetupPage = lazyRoute('/cli/dns-setup', () => import('@/pages/cli/dns-setup/index.page'));
export const OnboardingVerificationPage = lazyRoute(
  '/onboarding/verification',
  () => import('@/pages/onboarding/verification/index.page'),
);
export const OnboardingWizardPage = lazyRoute(
  '/onboarding/wizard',
  () => import('@/pages/onboarding/wizard/index.page'),
);
export const HarSanitizerPage = lazyRoute('/har-sanitizer/*', () => import('@/pages/har-sanitizer/index.page'));
export const NoAccessibleWorkspacesPage = lazyRoute(
  '/no_accessible_workspaces/*',
  () => import('@/pages/no-accessible-workspaces.page'),
);
export const PostCancelPage = lazyRoute('/post_cancel/*', () => import('@/pages/post-cancel.page'));
export const AccountCanceledPage = lazyRoute(
  '/account_canceled/*',
  () => import('@/pages/account-canceled/index.page'),
);
export const AcceptGuestInvitationPage = lazyRoute(
  '/accept-guest-invitation',
  () => import('@/pages/accept-guest-invitation/index.page'),
);

export const GeosetsIndexPage = lazyRoute(
  '/workspaces/:workspaceId/geosets',
  () => import('@/pages/workspaces/geosets/index.page'),
);
export const GeosetsCreatePage = lazyRoute(
  '/workspaces/:workspaceId/geosets/new',
  () => import('@/pages/workspaces/geosets/create.page'),
);
export const GeosetsEditPage = lazyRoute(
  '/workspaces/:workspaceId/geosets/:geosetId/edit',
  () => import('@/pages/workspaces/geosets/edit.page'),
);
export const GeofencesIndexPage = lazyRoute(
  '/workspaces/:workspaceId/geosets/:geosetId/geofences',
  () => import('@/pages/workspaces/geofences/index.page'),
);
export const GeofencesCreatePage = lazyRoute(
  '/workspaces/:workspaceId/geosets/:geosetId/geofences/new',
  () => import('@/pages/workspaces/geofences/create.page'),
);
export const GeofencesImportPage = lazyRoute(
  '/workspaces/:workspaceId/geosets/:geosetId/geofences/import',
  () => import('@/pages/workspaces/geofences/import.page'),
);
export const GeofencesEditPage = lazyRoute(
  '/workspaces/:workspaceId/geosets/:geosetId/geofences/:geofenceId',
  () => import('@/pages/workspaces/geofences/edit.page'),
);
export const GeosetsImportPage = lazyRoute(
  '/workspaces/:workspaceId/geosets/import',
  () => import('@/pages/workspaces/geosets/import.page'),
);

export const ConditionViewerDevPage = lazyRoute('/workspaces/:workspaceId/dev/condition-viewer', () =>
  import('@/features/condition-viewer/dev/condition-viewer-dev-page').then((m) => ({
    default: m.ConditionViewerDevPage,
  })),
);
export const CampaignsDevPage = lazyRoute('/workspaces/:workspaceId/dev/db/campaigns', () =>
  import('@/pages/dev/db/campaigns-dev-page').then((m) => ({ default: m.CampaignsDevPage })),
);
export const ActionDevPage = lazyRoute('/workspaces/:workspaceId/dev/db/campaigns/actions/:actionId', () =>
  import('@/pages/dev/db/action-dev-page').then((m) => ({ default: m.ActionDevPage })),
);

export const PipelineSourcesJourneysPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/journeys',
  () => import('@/pages/workspaces/pipelines/sources/journeys.page'),
);
export const PipelineAddSourcePage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/add',
  () => import('@/pages/workspaces/pipelines/sources/add/index.page'),
);
export const PipelineAddSourceOptionPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/add/:sourceOptionId',
  () => import('@/pages/workspaces/pipelines/sources/add/[source-option-id].page'),
);
export const PipelineSourceLayoutPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/layout.page'),
);
export const PipelineSourceIndexPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/index.page'),
);
export const PipelineSourceDataInPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/data-in',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/data-in/index.page'),
);
export const PipelineSourceSyncRunsPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/imports',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/sync-runs.page'),
);
export const PipelineSourceSyncsPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/syncs',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/syncs.page'),
);
export const PipelineSourceDatabasesPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/databases',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/databases.page'),
);
export const PipelineSourceSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/settings',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/settings.page'),
);
export const PipelineSourceAddSyncPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/sources/:sourceId/syncs/add',
  () => import('@/pages/workspaces/pipelines/sources/[source-id]/add-sync.page'),
);
export const PipelineDestinationsJourneysPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/journeys',
  () => import('@/pages/workspaces/pipelines/destinations/journeys.page'),
);
export const PipelineAddDestinationPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/add',
  () => import('@/pages/workspaces/pipelines/destinations/add/index.page'),
);
export const PipelineAddDestinationOptionPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/add/:destinationOptionId',
  () => import('@/pages/workspaces/pipelines/destinations/add/[destination-option-id].page'),
);
export const PipelineDestinationLayoutPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/layout.page'),
);
export const PipelineDestinationIndexPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/index.page'),
);
export const PipelineDestinationDataOutPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/data-out',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/data-out/index.page'),
);
export const PipelineDestinationExportsPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/exports',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/exports.page'),
);
export const PipelineDestinationTesterPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/tester',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/tester.page'),
);
export const PipelineDestinationSettingsPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/settings',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/settings.page'),
);
export const PipelineDestinationSubscriptionsIndexPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/subscriptions',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/subscriptions/index.page'),
);
export const PipelineDestinationSubscriptionsAddPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/subscriptions/add',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/subscriptions/add.page'),
);
export const PipelineDestinationSubscriptionPage = lazyRoute(
  '/workspaces/:workspaceId/pipelines/destinations/:destinationId/subscriptions/:subscriptionId',
  () => import('@/pages/workspaces/pipelines/destinations/[destination-id]/subscriptions/[subscription-id].page'),
);
